import {ExternalSource} from "@/interfaces/externalsource/externalSource";
import {Donation} from "@/interfaces/donation/donation";
import {CaseInfo} from "@/interfaces/donation/donationcase/caseInfo";
import {Recipient} from "@/interfaces/donation/certificate/recipient";
import {Intermediary} from "@/interfaces/intermediary/intermediary";

export interface DonationCase {
  id: number;
  createdAt: string;
  updatedAt: string;
  recipient: Recipient;
  caseInfo: CaseInfo;
  externalSource: ExternalSource;
  donations: Array<Donation>
  defaultDonationCauseIds: number[] | null
  privacyLevel: PrivacyLevel,
  intermediary?: Intermediary
}

export enum PrivacyLevel {
  STANDARD = "STANDARD",
  LIMITED = "LIMITED",
  HIDDEN = "HIDDEN"
}
